import { configureStore } from "@reduxjs/toolkit";
import reportReducer from "./redux/reportSlice";
import notificationReducer from "./redux/notificationSlice";
import loginRedirectReducer from "./redux/loginRedirectSlice";

export function makeStore() {
  return configureStore({
    reducer: {
      report: reportReducer,
      notification: notificationReducer,
      loginRedirect: loginRedirectReducer
    },
  });
}

export default makeStore();
